import { render, staticRenderFns } from "./CameraModal.vue?vue&type=template&id=5b231730&scoped=true"
import script from "./CameraModal.vue?vue&type=script&lang=js"
export * from "./CameraModal.vue?vue&type=script&lang=js"
import style0 from "./CameraModal.vue?vue&type=style&index=0&id=5b231730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b231730",
  null
  
)

export default component.exports